import api from '../../api/index.js';
import ui from '../ui/actions.js';
import app from './actions.js';

import { featureFlagToAPI, featureFlagToStore, searchResultsToStore } from './transform.js';
import { toSubmissionError } from '~/utils/transform.js';


// =============================================================================
// Feature Flags
// =============================================================================
export const fetchFeatureFlags = () => async (dispatch) => {

    try {
        const { data } = await dispatch(api.get('/feature_flags'));

        dispatch(app.featureFlags.set(featureFlagToStore(data)));

    } catch (error) {
        throw error;
    }
};

export const postFeatureFlag = async (values, dispatch, { reset }) => {

    try {
        await dispatch(api.post('/feature_flags', {
            data: featureFlagToAPI(values.toJS()),
        }));

        dispatch(ui.flash.success({ header: 'Feature flag created' }));

        // clear form fields
        reset();

        await fetchFeatureFlags()(dispatch);


    } catch (error) {
        throw toSubmissionError(error);
    }
};

export const deleteFeatureFlag = name => async (dispatch) => {

    try {
        await dispatch(api.delete(`/feature_flags/${name}`));

        dispatch(ui.flash.success({ header: 'Feature flag removed' }));

        await fetchFeatureFlags()(dispatch);

    } catch (error) {
        dispatch(ui.flash.error({ header: 'Failed to remove feature flag' }));
        return error;
    }
};

// =============================================================================
// search
// =============================================================================
export async function searchByParams(params, dispatch) {
    // swagger-ui/#/noblehour/get_search
    if (params.deleted === undefined) {
        params.deleted = [true, false];
    }

    try {
        dispatch(app.search.isloading.set(true));
        const { data: { results } } = await dispatch(api.get('/search', { params }));
        dispatch(app.search.results.set(searchResultsToStore(results, params)));

    } catch (error) {
        dispatch(app.search.results.clear());
        throw toSubmissionError(error);
    }
}

// simulate searching by id
export async function searchByID(entity, id, dispatch) {
    try {
        dispatch(app.search.isloading.set(true));
        const { data } = await dispatch(api.get(`/${entity}/${id}`));
        dispatch(app.search.results.set([data]));

    } catch (error) {
        if (error.response.status === 404) {
            // simulate no results
            dispatch(app.search.results.set([]));
        } else {
            dispatch(app.search.results.clear());
            throw toSubmissionError(error);
        }
    }
}

// =============================================================================
// Types
// =============================================================================
export const fetchOrganizationTypes = () => async (dispatch) => {
    try {
        const { data } = await dispatch(api.get('/options/organization_types'));
        dispatch(app.types.organization.set(data));

    } catch (error) {
        throw error;
    }
};

// =============================================================================
// App Data
// =============================================================================
export const fetchAppData = () => dispatch => Promise.all([
    fetchFeatureFlags()(dispatch),
    fetchOrganizationTypes()(dispatch),
]);
